export default __webpack_public_path__ + "static/media/Killer1.f672e29d.jpg";